import { useSessao } from '../../auth/contexto'
import { podeFiscalizar } from '../../auth/permissoes'
import { BotaoLink } from '../../components/Botao'
import { EstadoVazio } from '../../components/Estados'
import { IconeDocumento } from '../../components/IconesDeDocumento'
import { TEXTOS } from '../../lib/glossario'

/**
 * Por que não dá para perguntar agora — e o que fazer.
 *
 * Sem documento, o caminho é enviar o TR (para quem pode) ou esperar a fiscalização. Indisponível por
 * outro motivo (IA não configurada, limite do mês), a frase vem do servidor, que sabe qual é.
 *
 * @param props qual dos dois casos, e o motivo do servidor
 * @returns o aviso
 */
export function SemConsulta({ tipo, motivo }: { tipo: 'sem-documentos' | 'indisponivel'; motivo?: string }) {
  const t = TEXTOS.consulta
  const { usuario } = useSessao()

  if (tipo === 'sem-documentos') {
    return (
      <EstadoVazio
        icone={<IconeDocumento className="h-8 w-8" />}
        titulo={t.semDocumentosTitulo}
        ajuda={t.semDocumentosTexto}
        acao={
          podeFiscalizar(usuario) ? (
            <BotaoLink to="/documentos" aparencia="primario">
              {t.irParaDocumentos}
            </BotaoLink>
          ) : undefined
        }
      />
    )
  }
  return (
    <div role="status" className="mb-4 rounded-xl bg-amber-50 px-4 py-3 text-sm text-amber-900 ring-1 ring-inset ring-amber-200">
      <p className="font-medium">{t.indisponivelTitulo}</p>
      {motivo && <p className="mt-1">{motivo}</p>}
    </div>
  )
}
